//配置相关
export default {
    debug: false, //开发者模式 不定义或者false表示正式模式
    //token有效期
    tokenExpire: 7200,
    //请求的url
    apiUrl: {
        // dev: '/api',
        // dev: 'https://hyreport-dev.azsoft.xin/api',
        dev: 'https://phonerpt.huangyebl.com/api', // 生产环境
        // pro: 'https://hyreport-dev.azsoft.xin/api' // 测试环境
        // pro: 'https://assistant.azsoft.xin/api' // 正式环境
        pro: 'https://phonerpt.huangyebl.com/api' // 生产环境
    },
    // linkUrl: 'https://asistanttest.azsoft.xin/api', // 测试环境
    // linkUrl: 'https://assistant.azsoft.xin/api', // 正式环境
    linkUrl: 'https://phonerpt.huangyebl.com/api', // 生产环境
    //请求白名单 无需常规token
    apiWhite: [
        '/User/login'
    ],
    //token缓存名
    tokenName: '__USER_TOKEN__',
    //商家id
    tenantID: '__TENANT_ID__',
    //商家name
    tenantName: '__TENANT_NAME__',
}


// WEBPACK FOOTER //
// ./src/config/config.js